module.exports = __webpack_public_path__ + "img/logo.a005c8ae.png";